import React from 'react';
import { Grid } from 'react-bootstrap';

import styles from './Dashboard.module.scss';

const Dashboard = () => {
  return <Grid className={styles.wrapper}></Grid>;
};

export default Dashboard;
